import React, { useState } from "react";
import styled from "styled-components";

const STemplate = styled.div`
  padding: 5px 20px;
  width: 100%;
  max-width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Template = () => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  return (
    <STemplate>
 <h5>Wzory podań i listów</h5>

<p>
Przykłady listów handlowych (Ejemplos de cartas comerciales):<br/>
&#x2022; <a href="#1">List przedstawiający (Carta de presentaci&oacute;n)</a><br/>
&#x2022; <a href="#2">Schemat listu handlowego (Esquema de la carta comercial)</a><br/>
</p>
<p>
Przykłady podań o pracę i innych:<br/>
&#x2022; <a href="#3">Podanie o pracę (Solicitud de empleo)</a><br/>
&#x2022; <a href="#4">Odpowiedź na podanie o przyjęcie do pracy (potwierdzająca) (Respuesta afirmativa a la solicitud
de empleo)</a><br/>
&#x2022; <a href="#5">Odpowiedź na podanie o przyjęcie do pracy (odmowna) (Respuesta negativa a la solicitud de
empleo)</a><br/>
&#x2022; <a href="#6">Prośba o wizę (Pedido de formularios de visado)</a><br/>
&#x2022; <a href="#7">Opinia (Opini&oacute;n)</a><br/>
&#x2022; <a href="#8">Przykładowe życiorysy</a> (<a href="#81">1</a>, <a href="#82">2</a>, <a href="#83">3</a>, <a href="#84">4</a>, <a href="#85">5</a>, <a href="#86">6</a>, <a href="#87">7</a>)<br/>
</p>
<p>Opracowanie przygotowane na podstawie książki <b>Nora Orłowska, Andrzej Orłowski - "Korespondencja handlowa i naukowa w języku hiszpańskim"</b>.</p>

<hr size="1"/>

<a name="1"><h4>List przedstawiający (Carta de presentaci&oacute;n)</h4></a>
<p>Muy se&ntilde;ores nuestros:<br/>
Tenemos el agrado de presentar al Sr. Santiago Rojas, Nuestro agente, quien le informar&aacute; sobre
las &uacute;ltimas mercaderías recibidas por nuestra firma.<br/>
Sin otro particular saludamos a Ud. atentamente</p>

<a name="2"><h4>Schemat listu handlowego (Esquema de la carta comercial)</h4></a>

Bardzo ważny jest sposób, w jaki umieszczamy treść listu na papierze, gdyż pomaga to w szybkim zrozumieniu tekstu.
Zawsze piszemy list handlowy na maszynie lub komputerze, zostawiając 3 do 4 cm marginesu po lewej stronie kartki
i około 2 cm z prawej. Musimy uważać, żeby margines górny i dolny był zbliżony w swoich rozmiarach i nie był mniejszy
od 3 cm.<br/><br/>

<table cellspacing="0" cellpadding="2" border="1" width="95%" align="center">
<tr><td width="30" align="center"><b><a href="#21">1</a></b></td><td colspan="3" align="right">
Jos&eacute; Martin y Cia.<br/>
Calle Soles 3<br/>
Monterrey<br/>
México
</td></tr>
<tr><td width="30" align="center"><b><a href="#23">3</a></b></td><td width="30%">AA.R/6.95</td>
<td width="30" align="center"><b><a href="#22">2</a></b></td><td align="right">Monterrey, 2 de julio de 1995</td></tr>
<tr><td width="30" align="center"><b><a href="#24">4</a></b></td><td colspan="3" align="left">
SR. Francisco Rojas<br/>
Gerente de Autorrajas S.R.L.<br/>
Pasadas 54<br/>
Sevilla<br/>
Espa&ntilde;a
</td></tr>
<tr><td width="30" align="center"><b><a href="#25">5</a></b></td><td colspan="3" align="left">
ASUNTO: pedido de accesorios
</td></tr>
<tr><td width="30" align="center"><b><a href="#26">6</a></b></td><td colspan="3" align="left">
Estimado se&ntilde;or:
</td></tr>
<tr><td width="30" align="center"><b><a href="#27">7</a></b></td><td colspan="3" align="left">
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
Estamos interesados en adquirir accesorios para autom&oacute;viles; preferentemente fundas y alfombras.
Con tal motivo nos agradar&iacute;a recibir muestras de Buena calidad, lista de precios y condiciones de pago.<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
Si la mercader&iacute;a es de nuestra satisfacci&oacute;n haremos pedidos regulares.
</td></tr>
<tr><td width="30" align="center"><b><a href="#28">8</a></b></td><td colspan="3" align="center">
Saludamos a usted atentamente.
</td></tr>
<tr><td width="30" align="center"><b><a href="#29">9</a></b></td><td colspan="3" align="center">
&lt;własnoręczny podpis&gt;
</td></tr>
<tr><td width="30" align="center"><b><a href="#210">10</a></b></td><td colspan="3" align="left">
ADJUNTO: lista de articulos requeridos
</td></tr>
<tr><td width="30" align="center"><b><a href="#211">11</a></b></td><td colspan="3" align="left">
P.D. Socios de la Federaci&oacute;n Internacional de Autom&oacute;viles.
</td></tr>
</table>

<p><a name="21">1. <b>Remitente</b> (nadawca)</a></p>
Dane o nadawcy piszemy na górze, po prawej stronie, w odległości ok. 3 cm od górnej krawędzi kartki. W niektórych
krajach hiszpańskojezycznych pisze się te dane w lewym górnym rogu strony lub nawet w lewym dolnym rogu, poniżej
podpisu nadawcy. W skład tych danych wchodzą:<br/>
- nazwa przedsiębiorstwa, instytucji lub imię i nazwisko nadawcy,<br/>
- adres,<br/>
- numer telefonu, teleksu, faksu.<br/>
Zwykle te informacje są drukowane na papierze firmowym i wtedy mogą zajmować cała szerokość kartki, wówczas
po hiszpańsku nazywamy ta część <b>membrente</b>.<br/><br/>
<table colspan="3"cellspacing="0" cellpadding="0" border="0"width="80%" align="center">
<tr><td align="left" width="50%" valign="top">
La Agraria<br/>
Constituci&oacute;n 64<br/>
M&aacute;laga<br/>
Espa&ntilde;a<br/>
tel. 56 - 8624<br/>
telex 7892 agra a
</td><td align="left" width="50%" valign="top">
Jos&eacute; Mart&iacute;n<br/>
calle del Herrero 7<br/>
Guadalajara<br/>
M&eacute;xico
</td></tr></table><br/>

<p><a name="22">2. <b>Lugar y fecha</b> (miejsce i data)</a></p>
Po prawej stronie, zostawiając jeden pusty wiersz pod blokiem 1, piszemy nazwę miasta i datę:<br/><br/>
C&oacute;rdoba, 30 de octubre de 1990.<br/>
Montevideo, abril 8 de 1993.<br/>
La Paz, 3.10.94.<br/>
Santiago, 14/5/95.<br/>

<p><a name="23">3. <b>Referencias</b> (dane identyfikacyjne)</a></p>
Po lewej stronie, na górze strony, firmy zwykle podają dane identyfikujące list zgodnie z własnymi normatywami.<br/>

<p><a name="24">4. <b>Destinario</b> (adresat)</a></p>
Charakterystykę adresata umieszczamy po lewej stronie, zostawiając jeden pusty wiersz pod blokiem 3, lub jeden
pusty wiersz pod blokiem 2, w wypadku, gdy blok 3 nie jest stosowany. W zależności od adresata w pierwszym piszemy
skrót <b>Sr.</b> (<b>se&ntilde;or</b>), <b>Sra.</b> (<b>se&ntilde;ora</b>) lub <b>Srta.</b> (<b>se&ntilde;orita</b>), a dalej jego imię
i nazwisko. Jeżeli adresat posiada tytuł, to piszemy go natychmiast po <b>Sr.</b>, <b>Sra.</b> lub <b>Srta.</b>
W drugim wierszu bloku piszemy stanowisko adresata, w trzecim zaś nazwę firmy, a w dalszej części adres wg wzoru
podanego poniżej.<br/><br/>
<table colspan="3"cellspacing="0" cellpadding="0" border="0"width="80%" align="center">
<tr><td align="left" width="50%" valign="top">
Sr. Dr. Jos&eacute; Rocha<br/>
Director de la<br/>
Editorial EFE<br/>
Posadas 610<br/>
Sevilla<br/>
Espa&ntilde;a
</td><td align="left" width="50%" valign="top">
Sra. Luc&iacute;a Pereira<br/>
Gerente General<br/>
Banco Nacional<br/>
Artigas 6234<br/>
Concepti&oacute;n<br/>
Uruguay
</td></tr></table><br/>

<p><a name="25">5. <b>Asunto</b> (sprawa)</a></p>
W niektórych listach można znaleźć rubrykę <b>asunto</b>, w której jest umieszczony bardzo skrótowo temat listu,
np.:<br/><br/>
ASUNTO: nuestro pedido No 465.<br/>
ASUNTO: oferta especial de primavera.<br/>
ASUNTO: envoi cheque No 6777849<br/><br/>

<p><a name="26">6. <b>Saludo</b> (wstępny zwrot grzecznościowy)</a></p>
Zostawiamy jeden wolny wiersz pod adresem odbiorcy lub pod <b>Asunto</b>, pisząc pozdrowienia wg wzorów:<br/><br/>
De mi consideraci&oacute;n:<br/>
De mi mayor conciderati&oacute;n:<br/>
De nuestra mayor considerati&oacute;n:<br/>
Muy se&ntilde;or m&iacute;o<br/>
Muy se&ntilde;ores m&iacute;os:<br/>
Muy se&ntilde;ores nuestros:<br/><br/>
W wypadku gdy nie znamy płci adresata, stosujemy jeden z trzech pierwszych podanych powyżej zwrotów.<br/><br/>
Kiedy list kierujemy do bliższej osoby lub do osoby, z którą korespondujemy od wielu lat, możemy pisać:<br/><br/>
Estimado amigo:<br/>
Estimado se&ntilde;or Vidal:<br/>
Estimada se&ntilde;ora de Lopez:<br/>
Estimados se&ntilde;ores:<br/>
Estimadas se&ntilde;oras:<br/>
Estimado colega:<br/>
Estimada colega:<br/>
Quiero colega:<br/><br/>
Trzy ostatnie zwroty używamy w listach pomiędzy naukowcami, prawnikami, inżynierami, ekonomistami, itp.<br/>
Pozdrowienia zawsze kończymy dwukropkiem.<br/><br/>

<p><a name="27">7. <b>Contenido</b> (treść listu)</a></p>
Tutaj opisujemy sprawę lub podajemy informację, którą chcemy przekazać.<br/>
Każdą sprawę należy przedstawiać od nowego akapitu, z utrzymaniem odległości dwóch wierszy od poprzedniego.
Wówczas łatwiej będzie czytać i odpowiadać adresatowi listu. Pierwszy akapit zawsze zaczynamy po dwukropku,
bezpośrednio za pozdrowieniami. Pozostałe akapity należy umieszczać na tej samej odległości. Można tez stosować
akapity w odstępach od trzech do pięciu spacji od lewego marginesu:<br/><br/>

<table colspan="3"cellspacing="0" cellpadding="0" border="0"width="100%" align="center">
<tr><td align="left" valign="top" colspan="2">Estimado se&ntilde;or:</td></tr>
<tr><td align="left" valign="top">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td><td>
Me es grato informarle que el 26 corriente inauguramos nuestra nueva exposici&oacute;n titulada
"Herencia del pasado ind&iacute;gena".<br/>
Con tal occasion lo invitamos cordialmente al acto que se realizar&aacute; en nuestra sala de la
calle Alberti 53, a las 18 horas.<br/>
Esperamos su grata presencia.
</td></tr>
</table><br/>

Kiedy tekst listu jest bardzo długi - tylko pierwszy akapit rozpoczynamy wg podanego wzoru, a pozostałe umieszczamy
w odstępach trzech lub pięciu znaków:<br/><br/>

<table colspan="3"cellspacing="0" cellpadding="0" border="0"width="100%" align="center">
<tr><td align="left" valign="top" colspan="2">Estimados Se&ntilde;ores:</td></tr>
<tr><td align="left" valign="top">&nbsp;&nbsp;&nbsp;</td><td>
Hemos recibido su carta del 23 de marzo en la que nos informan sobre la nueva oferta de mercader&iacute;as para la
pr&oacute;xima estaci&oacute;n oto&ntilde;al.<br/>
Adjuntamos lista de pedidos. Pagaremos en la forma habitual enviando una remesa de dinero al recibir
la mercader&iacute;a.<br/>
Por favor ind&iacute;quennos la fecha exacta de la salida de los paquetes.<br/>
Saludamos a ustedes atentamente.
</td></tr>
</table><br/>

<p><a name="28">8. <b>Despedida</b> (pożegnanie)</a></p>
Musi być ono krótkie i zawierać odpowiednie wyrazy szacunku. Pisze się je w tej samej osobie co
i cały tekst listu:<br/><br/>
Saludo a usted muy atentamente. (1 os.)<br/>
Saluda a usted muy atentamente. (3 os.)<br/>
Saludo a usted. (1 os.)<br/>
Saluda a usted. (3 os.)<br/>
Le Saluda muy atentamente. (3 os.)<br/>
Atentamente.<br/>
Muy atentamente.<br/><br/>
W wypadku, kiedy list był bardziej osobisty (np. między przyjaciółmi), pożegnanie powinno mieć charakter osobisty,
np.:<br/><br/>
Un cordial saludo.<br/>
Hasta la vista.<br/><br/>

<p><a name="29">9. <b>Firma</b> (podpis)</a></p>
Pod własnoręcznym podpisem piszemy imię i nazwisko, tytuł lub stanowisko nadawcy. Jeśli osoba, która podpisze list,
robi to w imieniu innej, to umieszcza przed swoim podpisem skrót <b>p.p.</b> (<b>por poder</b>) lub <b>p.o.</b>
(<b>por orden</b>).<br/><br/>
<table colspan="3"cellspacing="0" cellpadding="0" border="0"width="80%" align="center">
<tr><td align="left" width="50%" valign="top">
Juan Lopez Parera<br/>
Jefe de Ventas
</td><td align="left" width="50%" valign="top">
p.p. Esteban Fern&aacute;ndez<br/>
secretario
</td></tr></table><br/>

<p><a name="210">10. <b>Adjunto</b> lub <b>Anexo</b> (załącznik)</a></p>
Jeżeli do listu załączamy dodatkowe dokumenty, to po lewej stronie, trochę niżej niż podpis, podajemy skrót <b>ADJ.</b>
lub <b>ANEXO</b> i informacje o tych dokumentach.<br/><br/>
ADJ. Lista de precios<br/>
ADJ. Cat&aacute;logo<br/>
ANEXO boleto No 8590<br/>
ANEXO invitaci&oacute;n para la Feria<br/><br/>

<p><a name="211">11. <b>P.D.</b> (postscriptum)</a></p>
Dopisek ten umieszczamy po lewej stronie na samym dole, kiedy chcemy udzielić ostatniego wyjaśnienia lub uzupełnić
podawane informacje.<br/><br/>
P.D. en caso de no poder asistir a la reunion, haga el favor de avisarnos.<br/>
P.D. dentro del paquete encontrar&aacute; la factura.<br/><br/>

<p><a name="212">12. <b>Sobre</b> (koperta)</a></p>
Piszemy adres w ten sam sposób jak w liście. Można w lewym górnym rogu zaznaczyc rodzaj przesyłki:<br/><br/>

<table colspan="3"cellspacing="0" cellpadding="0" border="0"width="95%" align="center">
<tr><td align="right" width="30%" valign="top">
via aerea<br/>
por avion<br/>
urgente<br/>
expreso expres<br/>
certificado<br/>
impresos<br/>
muestras sin valor<br/>
apartado de correos<br/>
casilla de correos<br/>
contra reembolso<br/>
a reembolso
</td><td>&nbsp;</td><td align="left" width="65%" valign="top">
lotnicza<br/>
lotnicza<br/>
expres<br/>
expres<br/>
polecony<br/>
druki<br/>
próbki towaru bez wartości handlowej<br/>
skrytka pocztowa<br/>
skrytka pocztowa<br/>
opłata za pokwitowaniem<br/>
opłata za pokwitowaniem
</td></tr></table><br/>

<div align="right"><a href="#top">do góry</a></div>

<hr size="1"/>

<a name="3"><h4>Podanie o pracę (Solicitud de empleo)</h4></a>

De mi mayor consideraci&oacute;n:<br/>
He le&iacute;do en el peri&oacute;dico local que la firma que usted dirige busca un jefe de compras,
con tal motivo presento mi candidatura para ese puesto.<br/>
Soy agresado de la Facultad de Ciencias Econ&oacute;micas. Desde hace 2 a&ntilde;os estoy trabajando en la
firma Soler y C&iacute;a. Y poseo buenas referencias.<br/>
Me interesa un empleo en una empresa m&aacute;s importante donde pueda tener mejores oportunidades
de ascenso.<br/><br/>
A la espera de su respuesta lo saludo muy atentamente.<br/><br/>
Adjunto: fotocopia diploma<br/>
referencias<br/>
cerfiticados de ex&aacute;menes de idiomas.<br/>
<hr size="2" width="10%" align="center"/>
Muy senor m&iacute;o:<br/>
Con sumo placer me dirijo a usted para postularme para el puesto de secretaria.<br/>
Hace 5 a&ntilde;os termin&eacute; el curso de la Academia Comercial y desde entonces estuve trabajando en las oficinas Dante.
Tengo experiencia en contabilidad, mecanografia, s&eacute; manejar un ordenador y hablo ingl&eacute;s.<br/>
Incluyo copias de mi certificado de trabajo y cartas de recomendaci&oacute;n.<br/>
Esperando que mi pedido sea favorablemente considerado, me despido de usted con el mayor respeto.<br/>
<hr size="2" width="10%" align="center"/>
Estimado se&ntilde;or:<br/>
Con referencia a su anuncio publicado en El Pa&iacute;s pidiendo un ayudante de contador, me permito presentar mi
solicitud de empleo.<br/>
Tengo 24 a&ntilde;os y soy egresado de la Facultad de Econom&iacute;a de la Universidad de Buenos Aires. Paralelamente a los
estudios asist&iacute; a cursos de programaci&oacute;n de ordenadores personales. Conozco  tambi&eacute;n perfectamente el idioma ingl&eacute;s.<br/>
Aunque a&uacute;n no poseo experiencia tratar&eacute; de realizar mi trabajo lo mejor posible.<br/>
Conf&iacute;o en que mi solicitud ser&aacute; aceptada. Lo saludo muy atte.<br/><br/>
<div align="right">Julio Mart&iacute;nez</div><br/>
Adj.: curriculum vitae<br/>
fotocopia diploma<br/>
fotocopia certificado curso de programaci&oacute;n<br/>
fotocopia certificado estudios de ingl&eacute;s<br/>

<a name="4"><h4>Odpowiedź na podanie o przyjęcie do pracy (potwierdzająca) (Respuesta afirmativa a la solicitud
de empleo)</h4></a>

Estimado se&ntilde;or:<br/>
Despu&eacute;s de haber examinado su solicitud hemos decidido emplearlo en el puesto de ayudante de contador, por esa raz&oacute;n
le pedimos que se presente el jueves 16 en nuestras oficinas a las 10 hs. para fijar las condiciones del contrato.
Nos agradar&iacute;a que empezara a trabajar el lunes 20.<br/>
Lo saludamos atentamente.<br/>
<hr size="2" width="10%" align="center"/>
Estimado se&ntilde;orita:<br/>
Con referencia a su carta del 14 de marzo del ete, me gustar&iacute;a invitarla a una entrevista personal el jueves 30,
a las 10 horas en nuestras oficinas.<br/>
Si la fecha no le conviene comuniquese telef&oacute;nicamente conmigo (75-883).<br/>
Saludo a Ud.<br/>

<a name="5"><h4>Odpowiedź na podanie o przyjęcie do pracy (odmowna) (Respuesta negativa a la solicitud de
empleo)</h4></a>

De mi consideraci&oacute;n:<br/>
En respuesta a su atenta carta del 14 del ete, lamento informarle que en este momento nos es imposble tomar nuevos
empleados, sin embargo tendremos en cueta su pedido en cuato se presente una oportunidad.<br/>
Me despido de usted con mucha consideraci&oacute;n.<br/>
<hr size="2" width="10%" align="center"/>
Muy se&ntilde;or mio:<br/>
Siento tener que informarle que puesto de ayudante de contador ya ha sido ocupado, su solicitud fue seriamente
considerada pero necesitamos una persona con m&aacute;s experiencia.<br/>
Lo saludo atentamente.<br/>

<a name="6"><h4>Prośba o wizę (Pedido de formularios de visado)</h4></a>

De mi mayor consideraci&oacute;n:<br/>
Tengo el agrado de solicitar formularios para obtener una visa para visitar su pa&iacute;s en el mes de octubre.
El motivo del viaje es estrechar contactos con las firmas que est&aacute;n relacionadas con la compa&ntilde;&iacute;a que
represento.<br/>
Sin otro particular y agradeci&eacute;ndole la atenci&oacute;n prestada me despido de usted.<br/>

<a name="7"><h4>Opinia (Opini&oacute;n)</h4></a>

<div align="center">Opini&oacute;n</div><br/>
El Dr. Rub&eacute;n Carreras, nacido en Buenos Aires, el 10 de julio de 1946, se ha recibido en la Universidad
de Buenos Aires, Facultad de Ciencias Econ&oacute;micas, en 1968 con el t&iacute;tulo de Licenciado en Ciencias Econ&oacute;micas.<br/>
Inmediatamente despu&eacute;s de haber terminado sus estudios comenz&oacute; a trabajar en el Ministerio de Hacienda,
en el Departemento de Planeamiento.<br/>
En 1973 recibi&oacute; el t&iacute;tulo de Doctor en Ciencias Econ&oacute;micas en la Universidad de Buenos Aires.<br/>
Realiz&oacute; numerosos cursos de perfeccionamiento.<br/>
En 1980 fue ascendido al cargo de Subdirector del Departamento de Planeamiento.<br/>
El Dr. Carreras es una persona de conducta intachable, que cumple seriamente con sus deberes y dedica toda su
atenci&oacute;n a los temas del Departamento, monstrando dotes de inteligencia e iniciativa.<br/>
En mi opini&oacute;n el Dr. Carreras merece el ascenso para e que ha proguesto su candidatura.<br/>

<a name="8"><h4>Przykładowe życiorysy</h4></a>

<a name="81"><div align="center">Curriculum Vitae</div></a><br/>
MIGUEL MOLINOS<br/>
OBJECTIVO: ocupar el puesto de Jefe de Exportaci&oacute;n<br/>
RESUMEN: 8 a&ntilde;os de experencia en exportaci&oacute;n. Al mismo tiempo, estudios realizados sobre el tema durante seis
a&ntilde;os de trabajo en la Facultad de Ciencias Econ&oacute;micas. Doctorado en Ciencias Econ&oacute;micas. Conocimiento del
mercado hispanoamericano. Trabajo con ordenador.<br/><br/>
EXPERIENCIA:<br/>
1988-1995 SALES. Compa&ntilde;&iacute;a de importaci&oacute;n.<br/>
Actualmente en el puesto de subjefe de la secci&oacute;n exportaci&oacute;n, con amplia experiencia en ventas a Am&eacute;rica Latina.
Numerosos viajes a diferentes pa&iacute;ses del &aacute;rea.<br/>
1986-1992 Facultad de Ciencias Econ&oacute;micas. Adjunto en la c&aacute;tedra de Comercio Exterior. Cursos sobre uso
de programas de computadoras para la organizaci&oacute;n del comercio exterior. Estudios de doctorado.<br/>
1985-1987 Roca Hnos. Ayudante de contadur&iacute;a, posteriormente empleado en secci&oacute;n de transacciones
financieras, exportaci&oacute;n.<br/><br/>
EDUCACION:<br/>
1980-1985 Universidad de C&oacute;rdoba. Facultad de Ciencias Econ&oacute;micas. Diploma de Licenciado en Ciencias Econ&oacute;micas.<br/>
1992 Diploma de Doctor de Ciencias Econ&oacute;micas.<br/><br/>
IDIOMAS: ingl&eacute;s, franc&eacute;s.<br/><br/>
DATOS PERSONALES: Nacido en 1961. Casado, dos hijos.<br/><br/>
REFERENCIAS: Universidad de C&oacute;rdoba. Sales. Roca Hnos.<br/>

<hr size="2" width="10%" align="center"/>
<a name="82"><div align="center">Curriculum Vitae</div></a><br/>
Nac&iacute; el 11 de marzo de 1946 en Matanzas. Mi padres, Juan Esteban Pardo, nacido el 17 de agosto de 1920 en esta
misma ciudad, es comerciante. Mi madre Maria del Carmen Rodr&iacute;guez, nacida el 20 de diciembre de 1926, es empleada.
Tengo dos hermanas, la mayor, Isabel, nacida el 10 de enero de 1948, es maestra y la menor, Julia, nacida el 4 de
marzo de 1950 es farmac&eacute;utica.<br/>
Concurr&iacute; a la escuela elemental entre los a&ntilde;os 1952 y 1959 al bachillerato entre 1959 y 1965.<br/>
En 1966 comenc&eacute; mis estudios en la Facultad de Econom&iacute;a de la Universidad Estatal, termin&aacute;ndolos en 1971 con el
t&iacute;tulo de Licenciado en Econom&iacute;a.<br/>
Posco buen conocimiento del idioma ingl&eacute;s y franc&eacute;s.<br/>
Desde 1972 trabajo en la Oficina de Exportaci&oacute;n "Navemar". En 1982 fui ascendido al puesto de Jefe de Ventas que
ocupo hasta la fecha.<br/>
Vivo en esta ciudad, en la calle Catalu&ntilde;a 16.<br/><br/>
<div align="right">Juan Miguel Pardo</div>

<hr size="2" width="10%" align="center"/>
<a name="83"><div align="center">Curriculum Vitae</div></a><br/>
Apellido: Pardo<br/>
Nombres: Juan Miguel<br/>
Fecha de nacimiento: 11 de marzo de 1946<br/>
Lugar de nacimiento: Matanzas<br/>
Nombre del padre: Juan Esteban<br/>
Fecha de nacimiento del padre: 17 de agosto de 1920<br/>
Profesi&oacute;n del padre: comerciante<br/>
Nombre y apellido de la madre: Mar&iacute;a del Carmen Rodr&iacute;guez<br/>
Fecha de nacimiento de la madre: 20 de diciembre de 1926<br/>
Profesi&oacute;n: empleada<br/>
Hermanas:<br/>
1. Isabel<br/>
&nbsp;&nbsp;&nbsp;Fecha de nacimiento: 10 en enero de 1948<br/>
&nbsp;&nbsp;&nbsp;Profesi&oacute;n: maestra<br/>
2. Julia<br/>
&nbsp;&nbsp;&nbsp;Fecha de nacimiento: 4 de marzo de 1950<br/>
&nbsp;&nbsp;&nbsp;Profesi&oacute;n: farmac&eacute;utica<br/><br/>
Curs&oacute; la<br/>
Escuela elemental en Matanzas, escuela No. 6 de 1952 a 1959.<br/>
el Bachillerato en Matanzas, de 1959 a 1965.<br/>
estudios universitarios en la Universidad Estatal, Facultad de Econom&iacute;a.<br/>
Finaliz&oacute; los studios: 1972.<br/>
T&iacute;tulo: Licenciado en Econom&iacute;a.<br/>
Idiomas: ingl&eacute;s, franc&eacute;s.<br/>
Trabajo: oficina de exportaci&oacute;n "Navemar".<br/>
Puesto: jefe de ventas (desde 1982).<br/>

<hr size="2" width="10%" align="center"/>
<a name="84"><div align="center">Curriculum Vitae</div></a><br/>
Apellido: Centeno de Ramos<br/>
Nombres: Rosa Maria<br/>
Nombre del padre: Ra&uacute;l<br/>
Nombre y apellido de la madre: Alicia Gonz&aacute;lez<br/>
Fecha y lugar de nacimiento: 10,octubre, 1958, Colonia<br/>
Casada con: Jos&eacute; Ramos, el 10 de setiembre de 1980.<br/>
Profesi&oacute;n del marido: ingeniero<br/>
Lugar de trabajo del marido: Telecine, calle 195, No. 64, Montevideo<br/>
Hijos: Miguel Ramos, nacido el 20 de julio de 1990.<br/><br/>
Estudios:<br/>
Escuela primaria: 1964-1971<br/>
Escuela media: 1971-1976<br/>
Academia de correspondencia y contabilidad: 1976-1979<br/>
Curso de ingl&eacute;s<br/>
Curso de franc&eacute;s<br/>
Curso de taquimecanograf&iacute;a<br/><br/>
Experiencia:<br/>
Desde 1978 secretaria en la Compa&ntilde;ia de Viajes Eurotur.<br/><br/>
<div align="center">Rosa Centeno de Ramos</div>

<hr size="2" width="10%" align="center"/>
<a name="85"><div align="center">Curriculum Vitae</div></a><br/>
Apellido: Molina<br/>
Nombres: Sebasti&aacute;n<br/>
Lugar y Fecha de nacimiento: Barcelona, 6 de julio de 1942<br/>
<table cellspacing="0" cellpadding="0" border="0">
<tr><td valign="top">Educaci&oacute;n:&nbsp;</td><td>primaria (1948-1954)<br/>
secundaria: bachillerato (1955-1959)<br/>
universitaria: Universidad de Madrid, Facultad de Humanidades (1960-66), licenciatura 1975,  doctorado
</td></tr></table>
T&iacute;tulo universitario: Doctor en Geograf&iacute;a<br/><br/>
Lugar de trabajo: Universidad de C&oacute;rdoba.<br/>
Puesto: Profesor de Geograf&iacute;a<br/>
T&iacute;tular de la C&aacute;tedra Geograf&iacute;a Regional Americana<br/><br/>
Beca de perfeccionamiento: M&eacute;xico (1973-74)<br/><br/>
Estado civil: soltero<br/>
Domicilio: Col&oacute;n 583, C&oacute;rdoba. Tel&eacute;fono 65-4378<br/><br/>
Lista de trabajos publicados en hoja adjunta.<br/><br/>
Dr. Sebasti&aacute;n Molina

<hr size="2" width="10%" align="center"/>
<a name="86"><div align="center">Curriculum Vitae</div></a><br/>
Nombre y apellido: Rub&eacute;n Carreras<br/>
Direcci&oacute;n: Buenos Aires, Cerrito 426 4 A.<br/>
Lugar y Fecha de nacimiento: Buenos Aires, 10.09.1946.<br/>
Estado civil: casado<br/><br/>
<table cellspacing="0" cellpadding="0" border="0">
<tr><td valign="top">Educaci&oacute;n:&nbsp;</td><td>primaria: 1952-1958<br/>
secundaria: Escuela Comercial No. 2 (1959-1963)<br/>
universitaria: Universidad de Buenos Aires, Facultad de Ciencias Econ&oacute;micas (1964-1968)<br/>
doctorado: Universidad de Buenos Aires, Facultad de Ciencias Econ&oacute;micas (1973)</td></tr></table><br/>
T&iacute;tulo universitario: Doctor en Ciencias Econ&oacute;micas<br/><br/>
Lugar de trabajo: Ministerio de Hacienda<br/>
Puesto: Subdirectior del Departamento de Planeamiento.<br/>
Miembro del Consejo de Planeamiento.<br/><br/>
Nombre de la esposa: Luisa Soler<br/>
Lugar y fecha de nacimiento: Rosario, 26 de enero de 1949.<br/>
Hijos:<br/>
Soledad (1971)<br/>
Guillermo(1975)<br/><br/>
Idiomas: ingl&eacute;s, italiano.<br/>
<div align="center">Dr. Rub&eacute;n Carreras</div>

<hr size="2" width="10%" align="center"/>
<a name="87"><div align="center">Curriculum Vitae</div></a><br/>
APELLIDO 1: Gonz&aacute;les<br/>
APELLIDO 2: P&eacute;rez<br/>
NOMBRES: Miguel Jos&eacute;<br/>
DIRECCION ACTUAL: Cerritos 23, La Paz<br/>
DIRECCION PERMANENTE: la misma<br/>
NUMERO DE TELEFONO: 456-3478<br/>
NUMERO DE DOCUMENTO DE IDENTIDAD: 3658745<br/>
DATOS PERSONALES:<br/>
Edad: 28 a&ntilde;os<br/>
Nacionalidad: chileno<br/>
Estado civil: soltero<br/><br/>
EDUCACION:<br/>
1972-1978 escuela primaria<br/>
1979-1983 escuela secundaria<br/>
1984-1988 universidad, Facultad de Ciencias Naturales y Miner&iacute;a<br/><br/>
EXPERIENCIA:<br/>
NOMBRE DE LA EMPRESA:<br/>
Establecimiento minero Pocitos, (1989-hasta la actualidad)<br/><br/>
IDIOMAS:<br/>
Lengua materna: castellano<br/>
Habla y escribe: ingl&eacute;s<br/>
Comprende: italiano, franc&eacute;s<br/><br/>
AFICIONES: nataci&oacute;n, tenis.<br/>
    </STemplate>
  );
};

export default Template;